
import VDPopupListbox from "@/components/pickers/VDPopupListbox.vue";
import {
  BasicOrganizationType,
  useGetBasicOrganisationsQuery,
} from "@/graphql/types";
import { useResult } from "@vue/apollo-composable";
import { computed, defineComponent, PropType, ref } from "vue";
import { VDPopupListboxClass } from "./VDPopupListbox";
import gql from "graphql-tag";
// Query
gql`
  query getBasicOrganisations {
    organizationsForRoleAssignee {
      count
      items {
        ...BasicOrganizationParts
      }
    }
  }
`;

export default defineComponent({
  components: {
    VDPopupListbox,
  },
  emits: ["addedOrganization"],
  props: {
    addedOrganizations: {
      type: Array as PropType<BasicOrganizationType[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    // VDOM
    const listbox = ref<VDPopupListboxClass>();

    // Refs
    const isEnabled = ref(false);

    // Data
    const { result, loading, error } = useGetBasicOrganisationsQuery(() => ({
      enabled: isEnabled.value,
    }));

    return {
      organizations: computed(
        () =>
          useResult(
            result,
            null,
            (data) => data?.organizationsForRoleAssignee?.items
          )
            .value?.slice()
            ?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "")) ?? []
      ),
      listbox,
      loading,
      error,
      toggle: (event: Event) => {
        isEnabled.value = true;
        listbox.value?.toggle(event);
      },
    };
  },
});
